<template>
    <span>
        <ports-cell v-bind="{row, options, value: row.ferry}" />
        <template v-if="agency || name">
            (<template v-if="agency">{{agency}}</template><template v-if="hasSeparator"> - </template><template v-if="name">{{name}}</template>)
        </template>
    </span>
</template>

<script>
import mixin from '../mixin';
import { Ports } from '@components/CRUD/Table/Cells';
export default {
    mixins: [ mixin ],
    components: { PortsCell: Ports },

    computed: {
        agency: function () {
            return !!this.row.agency
                ? this.row.agency.name
                : false;
        },

        name: function () {
            return !!this.row.ferry
                ? this.row.ferry.name
                : false
        },

        hasSeparator: function () {
            return this.agency && this.name;
        }
    }
}
</script>
